import { useQuery } from '@tanstack/react-query';
import { headlessGet } from '../lib/api';
import type { CollectionEntry, CollectionListResponse } from '../types/cms';

export function useRelatedEntries(
  targetCollection: string | undefined,
  relationField: string | undefined,
  currentEntryId: string | undefined,
  limit = 10,
): { data: CollectionEntry[]; isLoading: boolean } {
  const enabled = !!targetCollection && !!relationField && !!currentEntryId;

  const { data, isLoading } = useQuery({
    queryKey: ['related-entries', targetCollection, relationField, currentEntryId, limit],
    queryFn: () =>
      headlessGet<CollectionListResponse>(
        `/collections/${encodeURIComponent(targetCollection!)}?filter[${encodeURIComponent(relationField!)}]=${encodeURIComponent(currentEntryId!)}&limit=${limit}`,
      ),
    enabled,
    staleTime: 60_000,
    retry: false,
  });

  return { data: data?.entries ?? [], isLoading };
}
